(function (module) {
    'use strict';

    function subAccountSelectCtrl(Store) {
        this.$onInit = () => {
            this.subAccounts = Store.getMultiModelData('subAccounts');
            this.currentUser = Store.getCurrentUser();
            this.currentSubAccountId = Store.getCurrentSubAccountId();
        };

        this.change = () => {
            const subAccountId = Number(this.currentSubAccountId);
            Store.setCurrentSubAccountId(subAccountId);

            // notify parent
            this.onSubAccountChange({ $event: { subAccountId } });
        };
    }

    module.component('subAccountSelect', {
        templateUrl: '/js/components/sub-account-select/sub-account-select.html',
        controller: subAccountSelectCtrl,
        bindings: {
            onSubAccountChange: '&',
            disabled: '<',
        },
    });
})(angular.module('rocket.components'));
